import { FC, useCallback, useEffect, useState } from 'react'

import { ViewportSizes, lgStartPixels } from '@syconium/little-miss-figgy'

import { SlideItemProps } from '../constants'
import Iphone from '../Iphone'
import Slide from '../Slide'
import { DesktopViewWrapper, ImagePopUpWrapper, ImageWrapper } from '../style'

import PopUp from './PopUp'

interface DesktopViewProps {
  slideItems: SlideItemProps[]
  setIsFixed: (arg: number) => void
}

const DesktopView: FC<DesktopViewProps> = ({ slideItems, setIsFixed }) => {
  const [slide, setSlide] = useState(0)
  const { title, popper } = slideItems[slide]!
  const onScroll = useCallback(() => {
    const { pageYOffset } = window
    const slideId = Math.round(
      pageYOffset / Math.round(((window?.innerHeight - 380) * 7) / slideItems.length)
    )
    setIsFixed(
      pageYOffset -
        Math.round(((window?.innerHeight - 427.2) * 7) / slideItems.length) * slideItems.length
    )
    if (slideId >= 0 && slideId < slideItems.length) {
      setSlide(slideId)
    }
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide])

  const changeSlider = (slide: number) => {
    setSlide(slide)
    window.scroll(0, Math.round(((window?.innerHeight - 380) * 7) / slideItems.length) * slide)
  }

  useEffect(() => {
    setIsFixed(
      pageYOffset -
        Math.round(((window?.innerHeight - 427.2) * 7) / slideItems.length) * slideItems.length
    )
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (window.innerWidth >= lgStartPixels) {
      window.addEventListener('scroll', onScroll, { passive: true })
      return () => window.removeEventListener('scroll', onScroll)
    }
    return
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide])

  return (
    <DesktopViewWrapper>
      <ImageWrapper>
        <ImagePopUpWrapper>
          <Iphone slideItems={slideItems} index={slide} viewport={ViewportSizes.large} />
          <PopUp popper={popper} title={title} />
        </ImagePopUpWrapper>
      </ImageWrapper>
      <Slide slideItems={slideItems} slide={slide} setSlide={changeSlider} />
    </DesktopViewWrapper>
  )
}

export default DesktopView
